const FIELD_LABELS = {
  id: "客户/联系人 ID", code: "客户编号", customerId: "客户 ID", customerCode: "客户编号",
  name: "名称", customerName: "客户名称", shortName: "客户简称",
  country: "国家", countryName: "国家", provinceName: "省/州", cityName: "城市",
  address: "地址", operatorName: "负责人", ownerName: "负责人", sourceName: "客户来源",
  typeName: "客户类型", mainProduct: "主营产品", createTime: "创建时间", updateTime: "更新时间",
  email: "邮箱", phone: "电话", mobile: "手机", tel: "电话", website: "网站",
  remark: "备注", isDeleted: "删除标记", isDelete: "删除标记", isTrash: "回收站标记",
};

export function flattenRecord(value, prefix = "", output = {}) {
  if (Array.isArray(value)) {
    if (!value.length) output[prefix] = "";
    else value.forEach((item, index) => flattenRecord(item, `${prefix}[${index}]`, output));
  } else if (value && typeof value === "object") {
    const entries = Object.entries(value);
    if (!entries.length && prefix) output[prefix] = "";
    entries.forEach(([key, item]) => flattenRecord(item, prefix ? `${prefix}.${key}` : key, output));
  } else if (prefix) output[prefix] = value == null ? "" : String(value);
  return output;
}

export function fieldLabel(field) {
  const leaf = field.split(".").pop()?.replace(/\[\d+\]$/u, "") || field;
  const translated = FIELD_LABELS[leaf];
  if (!field.includes(".") && !field.includes("[")) return translated || field;
  return translated ? `${translated} · ${field}` : field;
}

export function formatJoinfTimestamp(value) {
  const text = String(value ?? "");
  // Joinf returns epoch milliseconds; do not pass a numeric string to Date.parse.
  if (!/^\d{10}(?:\d{3})?$/u.test(text)) return text || "—";
  const date = new Date(Number(text) * (text.length === 10 ? 1000 : 1));
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: "Asia/Shanghai", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  }).format(date);
}
